import { render, staticRenderFns } from "./SurveyResult.vue?vue&type=template&id=288f40ce"
import script from "./SurveyResult.vue?vue&type=script&lang=js"
export * from "./SurveyResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports